import { brandKitValidator } from "@redotech/redo-model/brand-kit";
import * as z from "zod/v4";

export const getBrandKit = {
  name: "getBrandKit" as const,
  input: z.null(),
  output: brandKitValidator,
};
